var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"width":"1000px","height":"500px"},attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData}})}
var staticRenderFns = []

export { render, staticRenderFns }